"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERTICAL_LAYOUT = exports.BASIC_LAYOUT = void 0;
exports.BASIC_LAYOUT = 8;
exports.VERTICAL_LAYOUT = 4;
//# sourceMappingURL=videos-per-page-count.js.map